import { useCallback } from "react";
import { BuildQuotesStates } from "../../enums/BuildQuoteStates";
import { fieldNames } from "../../Components/CreateJob/CreateJobView/BuildQuote/constant";

export const buildBasePayload = (
  getValues: any,
  customerAccount: string,
  company: string,
  leadId: string,
  jobNumber: string,
  emailPayload = {}
) => ({
  ...emailPayload,
  salesPersonId: getValues(fieldNames.SALES_PERSON),
  accountChargeLimit: "Cash Account",
  jobType: "Both",
  dropoff: `${getValues(fieldNames.DELIVERY_ADDRESS)}(${getValues(
    fieldNames.DELIVERY_COORDINATES
  )})`,
  leadId,
  accountTerms: "Net 0",
  company,
  jobNumber,
});

export const buildEstimatePayload = (
  getValues: any,
  basePayload: any,
  estimateTickedRows: any[],
  estimateSelectedField: string,
  company: string
) => {
  const cleanedList = estimateTickedRows.map(({ _key, ...rest }) => ({
    ...rest,
    id: "",
  }));

  return {
    ...basePayload,
    material: cleanedList,
    stageId: "Generate Estimate",
    estimate_agreementSectionTop: getValues(
      fieldNames.ESTIMATE_AGGREGATE_SUPPLY_1
    ),
    estimate_agreementSectionBottom: getValues(
      fieldNames.ESTIMATE_AGGREGATE_SUPPLY_2
    ),
    estimate_paymentTerms: getValues(fieldNames.ESTIMATE_PAYMENT_TERMS),
    estimate_thanksNotes: getValues(fieldNames.ESTIMATE_THANK_YOU),
    estimateAddressTerms: getValues(fieldNames.ESTIMATE_ADDRESS_HEADER),
    estimateHeader: getValues(fieldNames.ESTIMATE_HEADER),
    estimate_companyName: getValues(fieldNames.ESTIMATE_COMPANY_NAME),
    estimate_companyAddress: getValues(fieldNames.ESTIMATE_COMPANY_ADDRESS),
    estimate_companyContact: getValues(fieldNames.ESTIMATE_COMPANY_CONTACT),
    estimateSelectedField,
  };
};

export const buildQuotePayload = (
  getValues: any,
  basePayload: any,
  quoteTickedRows: any[],
  quoteSelectedField: string,
  signatureState: any,
  company: string
) => ({
  ...basePayload,
  material: quoteTickedRows,
  stageId: "Generate Quote",
  quote_agreementDescription: getValues(fieldNames.QUOTE_TEXT_AREA_INTRO),
  quote_paymemtTerms: getValues(fieldNames.QUOTE_PAYMENT_TERMS),
  quote_signature: getValues(fieldNames.QUOTE_SIGNATURE),
  quote_print_name: getValues(fieldNames.QUOTE_PRINT_NAME),
  quote_title: getValues(fieldNames.QUOTE_TITLE),
  quote_phone: getValues(fieldNames.QUOTE_PHONE),
  quote_email: getValues(fieldNames.QUOTE_EMAIL),
  quote_date: getValues(fieldNames.QUOTE_DATE),
  img_url: signatureState.url,
  quoteAddressTerms: getValues(fieldNames.TEMPLATE_ADDRESS_HEADER),
  quoteHeader: getValues(fieldNames.QUOTE_HEADER),
  quote_company_name: company,
  companyName: getValues(fieldNames.TEMPLATE_COMPANY_NAME),
  companyAddress: getValues(fieldNames.TEMPLATE_COMPANY_ADDRESS),
  companyContact: getValues(fieldNames.TEMPLATE_COMPANY_CONTACT),
  quoteSelectedField,
});

export const usePayloadBuilder = () => {
  const buildDownloadPayload = useCallback(
    (
      getValues: any,
      showEstimate: string,
      customerAccount: string,
      company: string,
      leadId: string,
      jobNumber: string,
      estimateTickedRows: any[],
      quoteTickedRows: any[],
      estimateSelectedField: string,
      quoteSelectedField: string,
      signatureState: any,
      email: boolean = false,
      selectedContact?: string
    ) => {
      let emailPayload = {
        email: {
          sent: false,
          companyId: "",
          projectId: "",
          contactId: "",
        },
      };

      if (email) {
        emailPayload.email.companyId = customerAccount;
        emailPayload.email.contactId = selectedContact;
        emailPayload.email.sent = true;
      }

      const basePayload = buildBasePayload(
        getValues,
        customerAccount,
        company,
        leadId,
        jobNumber,
        emailPayload
      );

      if (showEstimate === BuildQuotesStates.IS_ESTIMATE) {
        return buildEstimatePayload(
          getValues,
          basePayload,
          estimateTickedRows,
          estimateSelectedField,
          company
        );
      } else {
        return buildQuotePayload(
          getValues,
          basePayload,
          quoteTickedRows,
          quoteSelectedField,
          signatureState,
          company
        );
      }
    },
    []
  );

  return {
    buildDownloadPayload,
  };
};
